import { AddFilesModal } from '@/chat-common/components/source-dialogs/AddFilesModal'

type AddFilesMatterFilesDialogProps = {
  open: boolean
  matterId: string | null
  initialSelectedIds: string[]
  onClose: () => void
  onApply: (userFileIds: string[]) => void
}

/**
 * Matter Files picker for the timeline Add Files page. Thin wrapper over the shared
 * {@link AddFilesModal}, restricted to PDFs - the only type the timeline extracts. The shared
 * modal already gates non-completed files (processing / failed) out of selection, so this
 * wrapper only adds the PDF rule on top.
 */
export function AddFilesMatterFilesDialog({ open, matterId, initialSelectedIds, onClose, onApply }: AddFilesMatterFilesDialogProps) {
  // AddFilesModal requires a non-null matterId; there is nothing to browse without one.
  if (!matterId) return null

  return (
    <AddFilesModal
      open={open}
      matterId={matterId}
      initialSelectedFileIds={initialSelectedIds}
      onClose={onClose}
      onFilesSelected={onApply}
      isFileSelectable={(file) => file.detected_content_type === 'application/pdf'}
      fileNotSelectableMessage="PDF files only. The timeline only extracts PDFs."
    />
  )
}
